// menu-submenu.js

// Toggle de submenús anidados (niveles 2+)
document.addEventListener("click", function (event) {
  const toggle = event.target.closest("[data-submenu-toggle]");
  if (!toggle) return;

  event.preventDefault();
  event.stopPropagation(); // evita que Bootstrap cierre el dropdown padre

  const parentLi = toggle.closest(".dropdown-submenu");
  if (!parentLi) return;

  const submenu = parentLi.querySelector(".dropdown-menu");
  if (!submenu) return;

  const isOpen = submenu.classList.contains("show");

  // Opcional: cerrar submenús hermanos
  const siblings = parentLi.parentElement
    ? parentLi.parentElement.querySelectorAll(".dropdown-submenu .dropdown-menu.show")
    : [];
  siblings.forEach((sib) => {
    if (sib !== submenu) sib.classList.remove("show");
  });

  submenu.classList.toggle("show", !isOpen);
  toggle.setAttribute("aria-expanded", !isOpen ? "true" : "false");
});

// Al cerrar el dropdown principal, cerramos todos los submenús internos
document.addEventListener("DOMContentLoaded", function () {
  const dropdowns = document.querySelectorAll(".main-menu .dropdown");

  dropdowns.forEach((dropdownEl) => {
    dropdownEl.addEventListener("hide.bs.dropdown", () => {
      dropdownEl
        .querySelectorAll(".dropdown-menu.show")
        .forEach((submenu) => submenu.classList.remove("show"));

      dropdownEl
        .querySelectorAll("[data-submenu-toggle][aria-expanded='true']")
        .forEach((btn) => btn.setAttribute("aria-expanded", "false"));
    });
  });
});
